module.exports = __webpack_public_path__ + "img/Yanti.52ba6384.jpg";